export default __webpack_public_path__ + "static/media/watch-video.564621e5.webp";